function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var constants = require('@/js/constants');
var utils = {};

/**
 * Convert integer to String with min two dgits: "1" to "01", for date input
 * @param  {int}    number
 * @return {String} number string with
 */
utils.numToTwoDigits = function (number) {
  var numberStr = "".concat(number);
  numberStr = numberStr.length === 1 ? "0".concat(numberStr) : numberStr;
  return numberStr;
};
utils.getUtf8ByteSize = function (text) {
  return new Blob([text]).size; // Calcula los bytes en UTF-8
};

/**
 * Valitation for empty dict
 * @param  {Object} obj
 * @return {Object}
 */
utils.dictIsNotNull = function (obj) {
  var result = obj && Object.keys(obj).length > 0 && obj.constructor === Object;
  if (result) {
    return obj;
  }
  return result;
};

/**
 * Convert  string to Js Date Object '2019-12-01' to New Date(,m,d)
 * @param   {String}  strDate
 * @returns {Object}  Js Date Object
 */
utils.strServerDateToJsDate = function (strDate) {
  var isLastHourDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!_typeof(strDate.match(/string/i)) && !strDate.trim().match(/\d{4}-\d{1,2}-\d{1,2}$/)) {
    console.warn("strDate ".concat(strDate, " not match format"));
    return strDate;
  }
  var dateSplit = strDate.split('-');
  var year = parseInt(dateSplit[0]);
  var month = parseInt(dateSplit[1]);
  var day = parseInt(dateSplit[2]);
  var date = new Date(year, month - 1, day);

  // set las hour and minutes of day
  if (isLastHourDay) {
    date.setHours(23);
    date.setMinutes(59);
  }
  return date;
};

/**
 * @param  {Object}  optional, Date js object
 * @return {String}  Date format YYYY-MM-DD
 */
utils.getToDayString = function (myDate) {
  var day = myDate || new Date();
  var dayYear = day.getFullYear();
  var dayMonth = utils.numToTwoDigits(day.getMonth() + 1);
  var dayday = utils.numToTwoDigits(day.getDate());
  var dayString = "".concat(dayYear, "-").concat(dayMonth, "-").concat(dayday);
  return dayString.trim();
};
utils.getToDatetimeString = function (myDate) {
  var day = myDate || new Date();
  var dayYear = day.getFullYear();
  var dayMonth = utils.numToTwoDigits(day.getMonth() + 1);
  var dayday = utils.numToTwoDigits(day.getDate());
  var horas = String(day.getUTCHours()).padStart(2, '0');
  var minutos = String(day.getUTCMinutes()).padStart(2, '0');
  var segundos = String(day.getUTCSeconds()).padStart(2, '0');
  var dayString = "".concat(dayYear, "-").concat(dayMonth, "-").concat(dayday, " ").concat(horas, ":").concat(minutos, ":").concat(segundos);
  return dayString.trim();
};

/**
 * Transform Date String into Date js Object
 * @param  {String} dateString YYYY-MM-DD
 * @return {Object} Object Date
 */
utils.dateStringServerToDate = function (dateString) {
  var dateYMD = dateString.split('-');
  var date = new Date(dateYMD[0], dateYMD[1], dateYMD[2]);
  return date;
};

/**
 * Transform object date in seconds or milliseconds
 * @param  {Object} objDate  Object type date
 * @param  {String} format   Export format: 'js'=seconds; 'cdap'=milliseconds
 * @return {int} time in ms or s
 */
utils.dateToSeconds = function (objDate) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'js';
  var timeReturn = format;
  if (format === 'js') {
    // js format
    timeReturn = objDate.getTime() / 1;
  } else if (format === 'cdap') {
    // cdap format
    timeReturn = objDate.getTime() / 1000;
  } else {
    return objDate;
  }
  timeReturn = parseInt(timeReturn);
  return timeReturn;
};

/**
 * Transform Odject Dict in Array
 * @param  {Object} obj  Is a dict object
 * @return {Array}  [{keyName: key, ...}]
 */
utils.objectToArray = function (obj) {
  if (!obj || !_typeof(obj).match(/object/i)) {
    return obj;
  }
  var objKeys = Object.keys(obj);
  var objArray = [];
  for (var i = 0; i < objKeys.length; i++) {
    var value = obj[objKeys];
    var objToAdd = {};

    // create or add object
    var typeObj = _typeof(value);
    if (!typeObj.match(/string/i)) {
      objToAdd.value = value;
    } else {
      objToAdd = value;
    }
    objToAdd.keyName = objKeys;
    // add to array
    objArray.push(objToAdd);
  }
  return obj;
};

/**
 *
 * @param  {Object} defaultFields  fields from template table apply to table
 * @return {Object} dictionary with roles
 */
utils.getOwnersAndStewards = function (defaultFields) {
  var rolesFound = {};
  try {
    rolesFound.OWNER = defaultFields[constants.DEFAULT_TPL_FIELDS.OPERATOR.name].stringValue.toLowerCase();
    // TODO: stewards was hidden from metadata
    // rolesFound.AREA_DATA_STEWARD = defaultFields[constants.DEFAULT_TPL_FIELDS.AREA_DATA_STEWARD.name].stringValue.toLowerCase()
    // rolesFound.ORG_DATA_STEWARD = defaultFields[constants.DEFAULT_TPL_FIELDS.ORG_DATA_STEWARD.name].stringValue.toLowerCase()
    // rolesFound.CORP_DATA_STEWARD = defaultFields[constants.DEFAULT_TPL_FIELDS.CORP_DATA_STEWARD.name].stringValue.toLowerCase()
  } catch (e) {
    console.log("someones  stewards not was found, ".concat(e));
  }
  return rolesFound;
};

/**
 * @param  {Array}  fields  [{cloumn, fields, name, template...}]
 * @return {Array}  Array name fields
 */
utils.extractCellNameForView = function (fields) {
  var columnNames = [];
  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    var column = field.column;
    var columnRequired = column && field.fields.sensitive && field.fields.sensitive.include_in_flow;
    if (column && columnRequired && columnRequired === constants.ACCESS_TYPE_FLOW.INCLUDED) {
      columnNames.push(column);
    }
  }
  return columnNames;
};

/**
 * @param  {Boolean}  state  [{cloumn, fields, name, template...}]
 */
utils.setLoading = function (state) {
  window.userInfo.isLoading = state;
};

/**
 */
utils.getIsLoading = function () {
  return window.userInfo.isLoading;
};

/**
 * @param  {String} FIELD_NAME          Field name for compare with object Templates
 * @param  {Object} DEFAULT_TPL_FIELDS  Default templates fields in constats
 * @param  {Object} OWNER_TABLE         Owner Table from metadata table for valid owner permissions
 * @param  {Array}  ROLES_RESOURCE_LIST Roles list
 * @return {Booblean}                   If true is editable
 */
utils.fieldIsEdited = function (FIELD_NAME, tableRoles, isChangeRequest) {
  // if  type of FormMetadata is view this return alwais false to only view
  if (isChangeRequest === constants.TYPE_CHANGE_METADA.VIEWER_ONLY) {
    return false;
  }

  // exract user roles
  tableRoles = tableRoles || {};
  // get system roles
  var alluserRoles = utils.cloneJSON(window.userInfo.userRoles);
  // get all table default fields
  var fieldsAll = utils.cloneJSON(constants.DEFAULT_TPL_FIELDS);
  // mergeconcat/merge default table fields with UI Data permissions
  fieldsAll = Object.assign(fieldsAll, constants.UI_DATA_PERMISIONS);

  // extract  keys from roles list
  var rolesListKeys = Object.keys(constants.ROLES_RESOURCE_LIST);
  // extract user role list in each table default fields
  for (var i = 0; i < rolesListKeys.length; i++) {
    var roleKey = rolesListKeys[i];
    if (window.userInfo.email.toLowerCase() === tableRoles[roleKey]) {
      alluserRoles.push(constants.ROLES_RESOURCE_LIST[roleKey]);
    }
  }
  try {
    // if FormMetadata is type CHANGE_REQUEST (/ContObjectSearch) allow edit fields that are not owner or steward
    if (isChangeRequest === constants.TYPE_CHANGE_METADA.CHANGE_REQUEST && !FIELD_NAME.match(/(STEWARD)|(OPERATOR)/i)) {
      return true;
    }
    // compare user roles with fields required roles list
    var roleIsInField = utils.findArrayInArray(alluserRoles, fieldsAll[FIELD_NAME].roles);
    // find role in role field list
    if (roleIsInField && roleIsInField.length) {
      // exception for platform steward if is in search (only org_datasteward) on OWNER field
      if (isChangeRequest === constants.TYPE_CHANGE_METADA.CHANGE_REQUEST && FIELD_NAME === 'OPERATOR') {
        var evaluation = utils.findArrayInArray(roleIsInField, [constants.ROLES_LIST['ORG_DATA_STEWARD']]);
        if (evaluation && evaluation.length) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    } else {
      return false;
    }
  } catch (e) {
    // any alow edit
    console.warn(e);
    return true;
  }
};

/**
 * @param {*} e  for unify error alert
 */
utils.printError = function (e) {
  console.error('ERROR on ENDPOINT', e);
};

/**
 * @param  {String} dateString  "2019-12-30"
 * @return {String} date        "30-12-2019"
 */
utils.serviceDateToBrowser = function (dateString) {
  if (dateString.match(/\d{1,2}-\d{1,2}-\d{4}/)) {
    return dateString;
  }
  try {
    var dateSplite = dateString.split('-');
    var dateService = "".concat(dateSplite[1], "-").concat(dateSplite[2], "-").concat(dateSplite[0], " ");
    return dateService;
  } catch (err) {
    console.error(err);
    return dateString;
  }
};

/**
 * @param  {String} dateString  "30-12-2019"
 * @return {String} date        "2019-30-12"
 */
utils.dateBrowserToService = function (dateString) {
  if (dateString && dateString.match(/\d{4}-\d{1,2}-\d{1,2}/)) {
    return dateString;
  } else if (!dateString) {
    return '';
  }
  try {
    var dateSplite = dateString.split('-');
    var dateService = "".concat(dateSplite[2], "-").concat(dateSplite[0], "-").concat(dateSplite[1], " ");
    return dateService;
  } catch (err) {
    console.error(err);
    return dateString;
  }
};

/**
 * @param  {Object} jsonToClone  {..Any..}
 * @return {Object} cloned object...
 */
utils.cloneJSON = function (jsonToClone) {
  return JSON.parse(JSON.stringify(jsonToClone));
};

/**
 * @param  {Array} arrayContain  1,3]
 * @param  {Array} arrayIn       [1,2,3,4,5,6]
 * @return {Array} Array found
 */
utils.findArrayInArray = function () {
  var arrayContain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var arrayIn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var founded = [];
  var _loop = function _loop() {
    var masterItem = arrayContain[i];
    if (arrayIn) {
      var found = arrayIn.filter(function (subitem) {
        return subitem === masterItem;
      });
      if (found && found.length) {
        founded.push(found[0]);
      }
    }
  };
  for (var i = 0; i < arrayContain.length; i++) {
    _loop();
  }
  return founded;
};

/**
 * @param  {Array} fields   [{cloumn, field.stringValue="null", name, template...}]
 * @return {Array} rewrite  [{cloumn, field.stringValue="Null", name, template...}]
 */
utils.objectEmptyToNull = function (tags) {
  for (var i = 0; i < tags.length; i++) {
    var tag = tags[i];
    // filter for table fields
    if (tag.fields) {
      var fields = tag.fields;
      // iteration between fields
      var fieldsKeys = Object.keys(tag.fields);
      for (var j = 0; j < fieldsKeys.length; j++) {
        var field = fields[fieldsKeys[j]];

        // filter stringValue and change to Null id is empty
        if (field.stringValue !== undefined) {
          console.log("field ".concat(fieldsKeys[j], " with value ").concat(field.stringValue, " was empty?"));
          field.stringValue = field.stringValue.trim();
          // unify value to Null for empties
          if (field.stringValue === '' || field.stringValue.match(/^null$/i)) {
            field.stringValue = 'Null';
          }
        }
      }
    }
  }
  return tags;
};
utils.hasRole = function (role) {
  var roles = window.userInfo.userRoles || [];
  return roles.includes(role);
};
utils.driverConnectionFormat = function (fields) {
  var columnNames = [];
  for (var i = 0; i < fields.length; i++) {
    var field = fields[i];
    var column = field.column;
    var columnRequired = column && field.fields.sensitive && field.fields.sensitive.include_in_flow;
    if (column && columnRequired && columnRequired === constants.ACCESS_TYPE_FLOW.INCLUDED) {
      columnNames.push({
        'name': column,
        'type': field.fields.type.stringValue,
        'mode': field.fields.null.boolValue ? 'NULLABLE' : 'REQUIRED',
        'description': field.fields.business_definition.stringValue
      });
    }
  }
  return columnNames;
};
utils.getDomainFromEmail = function (email) {
  var emailDomain = null;
  var pos = email.search('@');
  if (pos > 0) {
    emailDomain = email.slice(pos + 1);
  }
  return emailDomain;
};
utils.timestampToDate = function (timestamp) {
  return new Date(timestamp);
};
utils.formatDate = function (date) {
  //console.log(date)
  var year = date.getFullYear();
  var month = (date.getMonth() + 1).toString().padStart(2, '0'); // La librería por defecto trabaja desde 0 a 11, se agrega el +1 para darle sentido al mes
  var day = date.getDate().toString().padStart(2, '0');
  return day + "/" + month + "/" + year;
};
utils.formatDateTime = function (date) {
  var formatUTC = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  //console.log(date)
  if (!date) return null;
  date = date instanceof Date ? new Date(date.getTime()) : new Date(date);
  if (formatUTC) {
    var _year = date.getUTCFullYear();
    var _month = date.getUTCMonth();
    var _day = date.getUTCDate();
    var _hour = date.getUTCHours();
    var minute = date.getUTCMinutes();
    var second = date.getUTCSeconds();
    date = new Date(Date.UTC(_year, _month, _day, _hour - 5, minute, second));
  }
  var year = date.getFullYear();
  var month = (date.getMonth() + 1).toString().padStart(2, '0'); // La librería por defecto trabaja desde 0 a 11, se agrega el +1 para darle sentido al mes
  var day = date.getDate().toString().padStart(2, '0');
  var hour = date.getHours().toString().padStart(2, '0');
  var minutes = date.getMinutes().toString().padStart(2, '0');
  var seconds = date.getSeconds().toString().padStart(2, '0');
  return day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds;
};
utils.setFormatDate = function (_fecha) {
  var fecha = _fecha.split("/");
  var date = new Date();
  date.setFullYear(fecha[2]);
  date.setMonth(fecha[1] - 1);
  date.setDate(fecha[0]);
  return date;
};
utils.parseFormatDate = function (date) {
  if (!date) return null;
  var _date$split = date.split('-'),
    _date$split2 = _slicedToArray(_date$split, 3),
    year = _date$split2[0],
    month = _date$split2[1],
    day = _date$split2[2];
  return "".concat(day, "/").concat(month, "/").concat(year);
};
utils.getPermissiosInMenuDict = function (routeName, menuDict) {
  /* used to obtain permissions in the MENU_DICT
      : param routeName : give the names of the routes
      : param menuDict : get data like roles, names and permissions of each role
     */
  for (var i = 0; i < menuDict.length; i++) {
    var menuItem = menuDict[i];
    var menuName = menuItem.href && menuItem.href.name;
    var subitems = menuItem.subItems;

    // get level 1
    if (menuName === routeName) {
      return menuItem.roles;
    }
    // get second level next
    if (subitems) {
      var roles = utils.getPermissiosInMenuDict(routeName, subitems);
      if (roles && roles.length > 0) {
        return roles;
      }
    }
  }
  return [];
};
utils.isObject = function (object) {
  return object != null && _typeof(object) === 'object';
};
utils.deepEqual = function (object1, object2) {
  var keys1 = Object.keys(object1);
  var keys2 = Object.keys(object2);
  if (keys1.length !== keys2.length) {
    return false;
  }
  for (var _i = 0, _keys = keys1; _i < _keys.length; _i++) {
    var key = _keys[_i];
    var val1 = object1[key];
    var val2 = object2[key];
    var areObjects = utils.isObject(val1) && utils.isObject(val2);
    if (areObjects && !utils.deepEqual(val1, val2) || !areObjects && val1 !== val2) {
      return false;
    }
  }
  return true;
};
utils.loadLanguage = function (words, objects, language) {
  Object.keys(objects).forEach(function (key) {
    if (Object.keys(objects[key]).includes("nivel")) {
      Object.keys(objects[key]).forEach(function (key2) {
        if (key2 != 'nivel') {
          if (!Object.keys(words).includes(key)) words[key] = {};
          if (Object.keys(objects[key][key2]).includes("nivel")) {
            Object.keys(objects[key][key2]).forEach(function (key3) {
              if (key3 != 'nivel') {
                if (!Object.keys(words[key]).includes(key2)) words[key][key2] = {};
                if (Object.keys(objects[key][key2][key3]).includes("nivel")) {
                  Object.keys(objects[key][key2][key3]).forEach(function (key4) {
                    if (key4 != 'nivel') {
                      if (!Object.keys(words[key][key2]).includes(key3)) words[key][key2][key3] = {};
                      words[key][key2][key3][key4] = objects[key][key2][key3][key4][language];
                    }
                  });
                } else {
                  words[key][key2][key3] = objects[key][key2][key3][language];
                }
              }
            });
          } else {
            words[key][key2] = objects[key][key2][language];
          }
        }
      });
    } else {
      words[key] = objects[key][language];
    }
  });
};
utils.loadLanguageRecursive = function (words, objects, language) {
  var _processObject = function processObject(currentWords, currentObjects) {
    Object.keys(currentObjects).forEach(function (key) {
      if (_typeof(currentObjects[key]) === 'object' && currentObjects[key] !== null) {
        if (currentObjects[key][language] !== undefined) {
          currentWords[key] = currentObjects[key][language];
        } else {
          if (!currentWords[key]) {
            currentWords[key] = {};
          }
          _processObject(currentWords[key], currentObjects[key]);
        }
      }
    });
  };
  _processObject(words, objects);
};
utils.validateEntryNameDataplex = function (relativeResourceName, projectId, datasetId, tableId) {
  if (relativeResourceName.indexOf(tableId) == -1) {
    return "projects/" + projectId + "/locations/us/entryGroups/@bigquery/entries/bigquery.googleapis.com/projects/" + projectId + "/datasets/" + datasetId + "/tables/" + tableId;
  }
  return relativeResourceName;
};
utils.traductor = function (i18n, key) {
  return i18n.t(key);
};
utils.downloadBlob = function (responseBlob, name) {
  var blob = new Blob([responseBlob], {
    type: 'application/octet-stream'
  });
  var link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
utils.downloadBase64 = function (base64, name) {
  var mimeType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'application/octet-stream';
  var cleanBase64 = base64.includes(',') ? base64.split(',')[1] : base64;
  var byteCharacters = atob(cleanBase64);
  var byteNumbers = new Array(byteCharacters.length);
  for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  var byteArray = new Uint8Array(byteNumbers);
  var blob = new Blob([byteArray], {
    type: mimeType
  });
  var link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
export default utils;